import { createSelector } from "reselect";
import * as R from "ramda";
import { getters } from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/model";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

export const getRevisions = createSelector(getters.record, record => {
  const revisions = R.path(
    ["expanded", STANDARD_MODULE_IDS.documentRequestRevisions.id, "records"],
    record
  );
  const sortedRevisions = R.pipe(
    R.values,
    R.sortBy(r => new Date(r.created_at))
  )(revisions);
  const reversedRevisions = R.reverse(sortedRevisions);
  return reversedRevisions;
});
